import { render, staticRenderFns } from "./BookingRef.vue?vue&type=template&id=b5d63606&"
import script from "./BookingRef.vue?vue&type=script&lang=js&"
export * from "./BookingRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports